<template src="./ConfigureEmpowerment.html"/>
<style lang="scss" scoped src="./ConfigureEmpowerment.scss"/>

<script>
import IMask from 'imask';
import {
  SfBreadcrumbs,
  SfButton,
  SfSelect,
  SfHeading,
  SfInput,
  SfTextarea,
  SfNotification,
  SfIcon,
  SfLoader,
  SfSection
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import icons from "@/utils/icons";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";


export default {
  name: 'ConfigureEmpowerment',
  transition: 'fade',
  components: {
    SfLoader,
    SfSection,
    OrkRecaptcha,
    SfBreadcrumbs,
    SfButton,
    SfHeading,
    SfInput,
    SfIcon,
    SfSelect,
    SfTextarea,
    SfNotification,
  },
  data() {
    return {
      monetPotBalance: {initial: null, current: null, error: null},
      icons: icons,
      locale: this.$i18n.locale,
      valid: false,
      submitted: false,
      form: {
        date: {year: "", month: ""},
        pncList: "",
        moneyPotDate: '',
        monthlyBudgetAmount: ''
      },
      pncListBlur: true,
      monthlyBudgetAmountBlur: true,
      moneyPotDateBlur: true,
      notification: {isVisible: false, message: "", type: "success"},
      notificationMoneyPot: {isVisible: false, message: "", type: "success"},
      loading: false,
      error: null,
      MpDate: null,
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('Configure empowerment'),
        }
      ]
    };
  },
  computed: {
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    }
  },
  mounted() {
    if (sessionStorage.getItem("configureEmpowerment")) {
      sessionStorage.removeItem("configureEmpowerment")
    } else {
      sessionStorage.setItem("configureEmpowerment", true)
    }

    sessionStorage.removeItem("empowerment")
    sessionStorage.removeItem("empowermentClient")
    const moneyPotDate = document.getElementById('moneyPotDate');
    const moneyPotDate_mask = new IMask(moneyPotDate, {
      mask: 'MM{/}YYYY',
      blocks: {
        YY: {
          mask: IMask.MaskedRange,
          from: 2023,
          to: 9999,
        },
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
        }
      }

    });
    if (this.isAuthenticated) {
      this.getEmpowermentBalance()
    }
  },
  methods: {

    getEmpowermentBalance() {
      Api.platform.getEmpowermentBalance()
          .then((data) => {
            this.monetPotBalance = {initial: data.initialBalance, current: data.balance}
          })
          .catch((e) => {

            this.monetPotBalance.error = e.message
            console.log(e)
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.unauthorized')
                break;
              case 422:
                error = e.message
                break;
              case 404:
                error = this.$i18n.t('errors.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case -1:
                error = this.$i18n.t('errors.connexion')
                break;
              case 0:
                error = this.$i18n.t('errors.server.connexion')
                break;
            }
            this.notificationMoneyPot = {
              isVisible: true,
              message: error,
              type: 'danger',
              icon: 'error'
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            this.submitted = true

          }).finally()
    },
    empowermentConnect() {
      sessionStorage.setItem("configureEmpowerment", true)
      const url = process.env.VUE_APP_HABILE_HTTP_VERSION + '://' + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + 'authorization.oauth2?client_id=' + process.env.VUE_APP_HABILE_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_HABILE_REDIRECT_URI + '&response_type=code&scope=openid email';
      window.location.href = url;
    },
    validBudget(budget) {
      return budget.length >= 2;
    },
    validCurrentDate(date) {
      const dateYear = Number(date.split('/')[1])
      const dateMonth = Number(date.split('/')[0] - 1)

      const q = new Date();
      const currentMonth = q.getMonth();
      const currentYear = q.getFullYear();
      const dateCM = new Date(dateYear, dateMonth);

      const formatDate = () => {
        this.form.date.year = Number(date.split('/')[1])
        this.form.date.month = date.split('/')[0]
      }

      if (dateCM.getMonth() > currentMonth - 1 && currentYear === dateCM.getFullYear()) {
        formatDate()
        return true;
      } else if (dateCM.getFullYear() > currentYear) {
        formatDate()
        return true;
      } else {
        return false;
      }

    },
    validMoneyPotDate(date) {
      if (date) {
        return this.validCurrentDate(date)
      }
      return false
    },
    validList() {

      const file = document.querySelector('#pncList');
      if (file.files[0]) {
        const ext = file.files[0].name.split('.').pop()
        if (ext.toLowerCase() === "xlsx") {
          if (file.files[0].size <= 5000000) {
            this.pncListBlur = true
            return true;

          }
          this.pncListBlur = false
          return false;
        }
        this.pncListBlur = false
        return false;
      }
      this.pncListBlur = false
      return false;

    },
    validate() {

      this.monthlyBudgetAmountBlur = false
      this.moneyPotDateBlur = false;
      this.pnclistBlur = false;
      if (
          this.validList() &&
          this.validMoneyPotDate(this.form.moneyPotDate) &&
          this.validBudget(this.form.monthlyBudgetAmount)
      ) {
        this.valid = true
      } else {
        this.valid = false
      }

    },
    submitForm(token) {
      this.validate()

      if (this.valid) {
        this.loading = true
        const list = document.querySelector('#pncList');

        Api.platform.configureEmpowerment(this.form, list.files[0], token)
            .then(() => {
                  this.submitted = true;
                  this.getEmpowermentBalance()
                  this.reset()
                  this.notification = {
                    isVisible: true,
                    message: this.$i18n.t('configureEmpowerment.success'),
                    type: 'success'
                  }
                }
            )
            .catch((e) => {
                  console.log(e)
                  let error = '';
                  switch (e.status) {
                    case 401:
                      error = this.$i18n.t('errors.unauthorized')
                      break;
                    case 422:
                      error = e.message
                      break;
                    case 404:
                      error = this.$i18n.t('errors.notFound')
                      break;
                    case 500:
                      error = this.$i18n.t('errors.server.access')
                      break;
                    case -1:
                      error = this.$i18n.t('errors.connexion')
                      break;
                    case 0:
                      error = this.$i18n.t('errors.server.connexion')
                      break;
                  }
                  this.notification = {
                    isVisible: true,
                    message: error,
                    type: 'danger',
                    icon: 'error'
                  }
                  this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
                  this.submitted = true
                }
            )
            .finally(() => {
              this.loading = false
            })
      }
    },

    reset() {
      this.form = {
        date: {year: "", month: ""},
        monthlyBudgetAmount: "",
        pnclist: "",
        moneyPotDate: ''
      };
      this.moneyPotDateBlur = true;
      this.pnclistBlur = true;
      this.monthlyBudgetAmountBlur = true;
      this.notification.isVisible = false;
    },
  }
};
</script>
